import { getStoredSignupGoal, type SignupGoalId } from '../constants/signupGoals';
import { GOAL_POST_PROFILE_PATHS, resolveGoalDestination } from './goalRouting';

export interface MsmeOnboardingState {
  hasCompanyName: boolean;
  hasProfile: boolean;
  hasDocuments: boolean;
  hasAssessment: boolean;
  workflowCompleted: boolean;
}

/**
 * Canonical MSME onboarding route: profile → bills → footprint → report goal home.
 * Operations / plant picture stays optional (sidebar / Advanced) — not a hard gate.
 * Shared by post-login routing and registration handoff so users see one consistent journey.
 */
export function resolveMsmeOnboardingDestination(
  state: MsmeOnboardingState,
  goal: SignupGoalId | null = getStoredSignupGoal()
): string {
  if (!state.hasCompanyName) {
    return '/msme-registration';
  }

  if (!state.hasProfile) {
    return '/msme-profile';
  }

  if (!state.hasDocuments) {
    if (goal && GOAL_POST_PROFILE_PATHS[goal]) {
      return GOAL_POST_PROFILE_PATHS[goal];
    }
    return '/document-upload';
  }

  if (!state.hasAssessment) {
    return '/carbon-footprint?section=start-assessment';
  }

  // Ops mapping is optional. After footprint, send users to their goal home (usually reporting / dashboard).
  return resolveGoalDestination(goal, '/dashboard');
}
